import { AutocompleteResultsType } from "@/components/compounds/forms/Autocomplete";

import { SitewideResultTypeEnum } from "../api/enums";
import type {
  ContentResult,
  PlaceResult,
  RegionResult,
  SearchFilterResult,
  SitewideResult,
  VenueResult,
} from "../api/types";

export function transformSitewideResults(
  data: Array<SitewideResult>,
): AutocompleteResultsType {
  return (data || []).map((result, index) => {
    // The Autocomplete component requires a unique `id` for rendering, but we
    // need to preserve the original `id` from region results for navigation.
    // We destructure the original `id` into `originalId` and use the `index`
    // for the `id` property required by Autocomplete.
    const { id: originalId, ...rest } = result as RegionResult;
    return {
      ...rest,
      id: index,
      originalId: originalId,
      // This cast fixes the TS error where the `type` string from the API
      // is not assignable to the more specific `SitewideResultTypeEnum`.
      type: result.type as SitewideResultTypeEnum,
    };
  });
}

type TransformedSitewideResult = SitewideResult & {
  originalId?: number;
};

export function getSitewideResultUrl(item: TransformedSitewideResult): string {
  const { type } = item;

  if (type === SitewideResultTypeEnum.REGION) {
    return `/search?region_ids=${item.originalId}`;
  }

  if (type === SitewideResultTypeEnum.SEARCH) {
    const { query } = item as SearchFilterResult;
    return `/search?${query}`;
  }

  const { slug } = item as unknown as ContentResult | PlaceResult | VenueResult;

  if (type === SitewideResultTypeEnum.PLACE) {
    return `/search?location=${slug},50`;
  }

  return `/${slug}`;
}
